import { lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { WithWrapperTabs } from "./components";

import {
  DEFAULT_OVERVIEW_PATH,
  DEFAULT_PEOPLE_PATH,
  OVERVIEW_PATH,
  OVERVIEW_PATH_WILDCARD,
  PEOPLE_PATH,
  PEOPLE_PATH_WILDCARD,
  UNKNOWN_TAB_PATH,
  UNKNOWN_TAB_PATH_WILDCARD,
} from "@octopus-settings/constants/config/router";

const Overview = lazy(() => import("../../overview"));
const People = lazy(() => import("../../people"));
// const ApiMcp = lazy(() => import("../../apiMcp")); enable in OOP2

const SettingsTabs = () => {
  const redirectToOverview = <Navigate to={DEFAULT_OVERVIEW_PATH} replace />;
  const redirectToPeople = <Navigate to={DEFAULT_PEOPLE_PATH} replace />;
  // const redirectToApiMcp = <Navigate to={DEFAULT_API_MCP_PATH} replace />; enable in OOP2

  return (
    <Routes>
      <Route index element={redirectToOverview} />
      <Route element={<WithWrapperTabs />}>
        <Route path={OVERVIEW_PATH} element={<Overview />} />
        <Route path={OVERVIEW_PATH_WILDCARD} element={redirectToOverview} />
        <Route path={PEOPLE_PATH} element={<People />} />
        <Route path={DEFAULT_PEOPLE_PATH} element={redirectToPeople} />
        <Route path={PEOPLE_PATH_WILDCARD} element={redirectToPeople} />
        {/* <Route
          path={API_MCP_PATH}
          element={
            <AdminRoute>
              <ApiMcp />
            </AdminRoute>
          }
        /> 
        <Route path={API_MCP_PATH_WILDCARD} element={redirectToApiMcp} /> enable in OOP2 */}
        <Route path={UNKNOWN_TAB_PATH} element={redirectToOverview} />
        <Route path={UNKNOWN_TAB_PATH_WILDCARD} element={redirectToOverview} />
      </Route>
    </Routes>
  );
};

export default SettingsTabs;
